import {inject} from '@angular/core';
import {CanActivateChildFn, CanActivateFn}from '@angular/router';
import { AuthService } from '../password-grant/auth.service';

export const AuthGuard: CanActivateFn | CanActivateChildFn = async (_route, state): Promise<boolean> => {
    const auth = inject(AuthService);

    const logged = await auth.isAuthenticated();
    if (!logged) {
        await auth.loginWithRedirect(state.url);
        return false;
    }

    return true;
};
